<template>
  <div class="online_support block danhmuc">
    <div class="block-title"><h5><i class="fa fa-bars"></i>Danh mục sản phẩm</h5></div>
    <div class="panel-group listCatProduct" id="accordion">
      <div class="panel"  v-for="(category, index) of categories"
      :key="index">
        <h4>
          <i class="fa fa-pagelines"></i>
          <router-link
            exact
            :to="{
              name: 'productByCategory',
              params: { slug: category.seoName }
            }"
          >
          {{category.name}}
          </router-link>
          <!-- <i
            class="fa fa-plus custom-show collapsed"
            href="#collapse0"
            data-toggle="collapse"
            data-parent="#accordion"
            aria-hidden="true"
            aria-expanded="false"
          ></i> -->
        </h4>
      </div>
    </div>
    <!-- end-listCatProduct -->
  </div>
</template>
<script>
export default {
  name: "RwvCategory",
  props: {
    categories: Array
  }
};
</script>
